import { Appointment } from "@/types/appointment.definition";
import { Facility } from "@/types/facility.definition";

/**
 * MED-1687: the facility name of an appointment. The BFF sends only its id, which the dashboard
 * showed ("ID de l'établissement : 1"); a manager or secretary only sees her own facility's
 * appointments, so its name comes from her session. Undefined when neither is known.
 */
export const appointmentFacilityName = (
  appointment: Pick<Appointment, "healthcareFacility" | "healthcareFacilityId">,
  ownFacility?: Pick<Facility, "id" | "name">,
): string | undefined =>
  appointment.healthcareFacility?.name ??
  (ownFacility && String(ownFacility.id) === String(appointment.healthcareFacilityId)
    ? ownFacility.name
    : undefined);
